import LTR from "@brand-icons/global/social-mail/social-mail-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialMailIcon = iconFactory("SocialMailIcon", LTR);
